import { t } from '@lingui/macro';

export const RECURRING_SWITCH_TEXT = (): string => t`Repeat every week?`;
export const RECURRING_SWITCH_TEXT_LONG = (): string =>
  t`Would you like to repeat this service each week?`;
export const RECURRING_SWITCH_INFO_TITLE = (): string => t`Repeat every week`;
export const RECURRING_SWITCH_INFO_CONTENT = (): string =>
  t`Recurring bookings allow you to choose whether you want a booking to repeat automatically every week. With this feature, bookings take place on the same day of the week and they'll repeat on an ongoing basis. You can discontinue recurring bookings at any time.`;
